import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { IFrameComponent } from 'components/IFrame'
import { TenantSelect } from './TenantSelect'
import { TenantService } from 'connection/TenantService'
import { Tenant } from 'connection/models/Tenant'
import { Layout } from 'antd'
import { ApplicationRoutes } from './ApplicationRoutes'
import { Navbar } from '../navbar/Index'
import Logo from '../../assets/images/cerberus_logo.png'
import { UserData } from 'connection/models/UserData'
import { LoadingFactory } from 'components/LoadingFactory'
import './Main.scss'
import { AppSettings } from '../../appSettings'

const { Header, Content, Footer, Sider } = Layout

const BILLING_FORMS = '/billing';
interface MainContentPageProps {
    userAuth: UserData;
}

export const MainContentPage = ({ userAuth } : MainContentPageProps) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [tenant, setSelectedTenant] = useState<Tenant>(null);
  const [isBillingForms, setIsBillingForms] = useState<boolean>(false);
  
  const checkUrlIsBillingForms = () => {
    if (location.pathname === BILLING_FORMS) {
      setIsBillingForms(true);
    } else {
      setIsBillingForms(false);
    }
  }
 
  const handleSelectedTenant = (selectedTenant: Tenant) => {
    TenantService.setSelectedTenant(selectedTenant)
    setSelectedTenant(selectedTenant)
  }

  const contentPage = () => {
    return <>
      <Header className="main-header">
        <TenantSelect onSelectTenant={handleSelectedTenant} />
      </Header>
      <Content className="main-content">
        <ApplicationRoutes tenant={tenant} userAuth={userAuth} />
      </Content>
      <Footer className="tc">Cerberus ©{new Date().getFullYear()}</Footer>
    </>
  }

  useEffect(() => {
    checkUrlIsBillingForms();
    setIsLoading(false);
  }, [location]);

  return (
    <Layout id="main-app" className="h-100">
      <Sider breakpoint="lg" width="280" collapsedWidth="0" className="sidebar">
        <div className="logo">
          <img src={Logo} alt="Cerberus Logo" />
        </div>
        <Navbar tenant={tenant ? tenant.name : ''} />
      </Sider>

      <Layout>
        { 
          isBillingForms ? <IFrameComponent src={AppSettings.get('BILLING_URI')} /> : isLoading ? <LoadingFactory /> : contentPage() 
        }
      </Layout>
    </Layout>
  )
}